<template>
  <div class="card order-view">
    <AccountPanel :title="'Zamówienie nr ' + orderId">
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">lp</th>
              <th scope="col" class="col-1">zdjęcie</th>
              <th scope="col">nazwa</th>
              <th scope="col">kod</th>
              <th scope="col">netto[jedn.]</th>
              <th scope="col">ilość</th>
              <th scope="col">netto</th>
              <th scope="col">vat</th>
              <th scope="col">brutto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(position, key) in order.position_list">
              <td scope="col">{{ key + 1}}.</td>
              <td scope="col" class="col-1">
                <img
                  :src="photoUrl(position.photo_url)"
                  :alt="position.photo_url"
                  class="img-fluid"
                />
              </td>
              <td scope="col">{{ position.name}}</td>
              <td scope="col">{{ position.code}}</td>
              <td scope="col" class="right">{{ formatPrice(position.price)}} PLN</td>
              <td scope="col">{{ position.quantity}}</td>
              <td scope="col" class="right">{{ formatPrice(position.price * position.quantity)}} PLN</td>
              <td
                scope="col"
                class="right"
              >{{ formatPrice(position.tax_value * position.quantity)}} PLN</td>
              <td
                scope="col"
                class="right"
              >{{ formatPrice(position.gross_value * position.quantity)}} PLN</td>
            </tr>

            <tr class="order-summary">
              <td colspan="6" class="right">Razem</td>
              <td class="right">{{formatPrice(order.total_net)}} PLN</td>
              <td class="right">{{formatPrice(order.total_tax)}} PLN</td>
              <td class="right">{{formatPrice(order.total_gross)}} PLN</td>
            </tr>
          </tbody>
        </table>
      </div>
    </AccountPanel>
  </div>
</template>




<script>
import { mapState } from "vuex";
import AccountPanel from "./../../account/src/account/AccountPanel.vue";

export default {
  components: { AccountPanel },
  props: ["orderId"],
  data() {
    return {
      order: {
        position_list: []
      }
    };
  },
  methods: {
    photoUrl(url) {
      if (url == "/nophoto.png") {
        return "//cdn01.redbay.pl/layouts/boma/img/noimg.jpg";
      }
      return url;
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },

  async beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }

    this.order = await this.$store.dispatch("order/getOrder", this.orderId);
  }
};
</script>




// WEBPACK FOOTER //
// src/components/order/src/OrderPage.vue